import React from "react";
import SimpleButton from "../../../../../modules/commons/SimpleButton";

export const modalBookingTableConfig = ({ onSelect }) => [
  {
    name: "customerName",
    label: "Nama Konsumen",
    value: "nama",
    options: { sort: false },
  },
  {
    name: "managementBookingId",
    label: "Kode Booking",
    value: "",
    options: { sort: false },
  },
  {
    name: "waHPNumber",
    label: "No. Telepon",
    options: { sort: false },
  },
  {
    name: "managementBookingId",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (val) => {
        return (
          <SimpleButton
            id="btn_select"
            styles={{ width: "unset" }}
            text="Pilih"
            onClick={() => onSelect(val)}
          />
        );
      },
    },
  },
];

export const modalClaimMainTableConfig = ({ onSelect, onShowDetail }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return page * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    label: "Tanggal Claim",
    name: "tanggalClaim",
    options: { sort: false },
  },
  { label: "ID Claim", name: "idClaim", options: { sort: false } },
  { label: "Nomor Claim", name: "nomorClaim", options: { sort: false } },
  {
    label: "Nama Pemilik",
    name: "namaPemilik",
    options: {
      sort: false,
      customBodyRender: (val, { rowData }) => {
        return (
          <p
            className="btnAct txt-site txt-blue"
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => onShowDetail(rowData[2])}
          >
            {val}
          </p>
        );
      },
    },
  },
  { label: "Kode Varian", name: "kodeVarian", options: { sort: false } },
  { label: "Nama Varian", name: "namaVarian", options: { sort: false } },
  { label: "Kode Warna", name: "kodeWaran", options: { sort: false } },
  { label: "Nama Warna", name: "namaWarna", options: { sort: false } },
  { label: "Nomor Rangka", name: "nomorRangka", options: { sort: false } },
  { label: "Nomor Mesin", name: "nomorMesin", options: { sort: false } },
  {
    label: "Aksi",
    name: "nomorClaim",
    options: {
      sort: false,
      customBodyRender: (val) => {
        return (
          <React.Fragment>
            <SimpleButton
              id="btn_select_claim"
              text="Pilih"
              styles={{ width: "unset" }}
              onClick={() => onSelect(val)}
            />
          </React.Fragment>
        );
      },
    },
  },
];

export const modalHotlinTableConfig = [
  { label: "Tangal HO", options: { sort: false } },
  { label: "No Hotline Order", options: { sort: false } },
  { label: "Nama Konsumen", options: { sort: false } },
  { label: "Aksi", options: { sort: false } },
];

export const modalProspectTableConfig = ({ onSelect }) => [
  { label: "Nomor Prospek", name: "prospectNo" },
  { label: "Pemilik Prospek", name: "pemilikProspek" },
  { label: "Nama", name: "name" },
  { label: "Telepon", name: "hpNumber1" },
  { label: "Alamat", name: "address" },
  { label: "Provinsi", name: "provinceId" },
  { label: "Kecamatan", name: "kecamatanId" },
  { label: "Kelurahan", name: "kelurahanId" },
  {
    label: "Aksi",
    name: "prospectNo",
    options: {
      customBodyRender: (val, { rowIndex }) => (
        <SimpleButton
          id="btn_select"
          text="Pilih"
          onClick={() => onSelect(rowIndex)}
        />
      ),
    },
  },
];

export const modalCustomerTableConfig = ({ onSelect }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <>{rowNumber}</>;
      },
      sort: false,
    },
  },
  {
    name: "name",
    label: "Nama",
    options: {
      sort: false,
    },
  },
  {
    name: "hpNumber1",
    label: "Telepon",
    options: {
      sort: false,
    },
  },
  {
    name: "nik",
    label: "NIK",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalLahir",
    label: "Tanggal Lahir",
    options: {
      sort: false,
    },
  },
  {
    name: "address",
    label: "Alamat",
    options: {
      sort: false,
    },
  },
  {
    name: "province",
    label: "Provinsi",
    options: {
      customBodyRender: (val) => <>{val?.label}</>,
      sort: false,
    },
  },
  {
    name: "kecamatan",
    label: "Kecamatan",
    options: {
      customBodyRender: (val) => <>{val?.label}</>,
      sort: false,
    },
  },
  {
    name: "kelurahan",
    label: "Kelurahan",
    options: {
      customBodyRender: (val) => <>{val?.label}</>,
      sort: false,
    },
  },
  {
    name: "",
    label: "Aksi",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
      customBodyRender: (_, { rowIndex }) => {
        return (
          <React.Fragment>
            <SimpleButton
              styles={{ width: "unset" }}
              text="Pilih"
              onClick={() => onSelect(rowIndex)}
            />
          </React.Fragment>
        );
      },
    },
  },
];
